// 基于Backbone.Events(Backbone.js 1.1.2)改造的事件注册中心，主要改造点如下：
// 1）简化接口和实现，去除暂时用不到的接口和功能。
// 2）支持事件缓存，确保事件不丢失

const slice = [].slice

/**
 * 订阅事件
 * @param {*} eventName 
 * @param {*} callback 
 * @param {*} context 
 */
export function on (eventName, callback, context) {
  const _registry = this._registry || (this._registry = {})
  const eventEntry = _registry[eventName] || (_registry[eventName] = {events: [], callbacks: []})
  eventEntry.callbacks.push({ callback: callback, context: context })
  _triggerCachedEvents(eventEntry, callback, context);
  return this
}

// Bind an event to only be triggered a single time. After the first time
// the callback is invoked, it will be removed.
export function once (eventName, callback, context) {
  let count = 0
  const self = this
  const onceCallback = function () {
    if (count++) {
      return
    }
    self.off(eventName, onceCallback)
    callback.apply(this, arguments)
  }
  onceCallback._callback = callback
  return this.on(name, onceCallback, context)
}

/**
 * 取消订阅事件
 * @param {*} eventName 
 * @param {*} callback 
 * @param {*} context 
 */
export function off (eventName, callback, context) {
  // 都为空，表示删除所有注册事件
  if (!eventName && !callback && !context) {
    delete this._registry
    return this
  }
  // 如果未指定事件，则遍历所有事件删除回调函数
  const allEvents = eventName ? [eventName] : Object.keys(this._registry)
  for (let i = 0, l = allEvents.length; i < l; i++) {
    let event = allEvents[i]
    const callbacks = this._registry[event].callbacks;
    if (callbacks) {
      const retain = this._registry[event].callbacks = []
      if (callback || context) {
        for (let j = 0, k = callbacks.length; j < k; j++) {
          const callbackItem = callbacks[j]
          if ((callback && callback !== callbackItem.callback && callback !== callbackItem.callback._callback) 
            || (context && context !== callbackItem.context)) {
            retain.push(callbackItem)
          }
        }
      }
      if (!retain.length) {
        delete this._registry[event];
      }
    } else {
      console.warn("Empty callbacks of event: " + event);
    }
  }
  return this
}

/**
 * 触发事件
 * @param {*} eventName 
 */
export function trigger (eventName) {
  if (!this._registry) {
    this._registry = {};
  }
  const args = slice.call(arguments, 1)
  const eventEntry = this._registry[eventName] || (this._registry[eventName] = {events:[], callbacks:[]});
  if (eventEntry.callbacks.length > 0) {
    _triggerEvents(eventEntry, args, this)
  } else {
    if (eventEntry.events.length < 1024) {
      eventEntry.events.push(args);
    } else {
      console.warn("Events queue is full, event: " + eventName);
    }
  }
  return this
}

/**
 * 触发缓存事件
 * @param {*} eventEntry 
 * @param {*} callback 
 * @param {*} context 
 */
function _triggerCachedEvents(eventEntry, callback, context) {
  if (eventEntry.events.length > 0) {
    for (const event of eventEntry.events) {
      callback.apply(context || this, event);
    }
    eventEntry.events = [];
  }
}

/**
 * 实时触发事件
 * @param {*} eventEntry 
 * @param {*} args 
 * @param {*} context 
 */
function _triggerEvents (eventEntry, args, context) {
  let i = -1;
  const l = eventEntry.callbacks.length;
  while (++i < l) {
    console.log(l)
    console.log(i)
    const callbackItem = eventEntry.callbacks[i];
    // 防止for循环被阻止
    try {
      callbackItem.callback.apply(callbackItem.context || context, args);
    } catch (er) {
      console.log(er)
    }
  }
}

export default {
  on, off, trigger, once
}
